import Cookies from 'js-cookie';
import { setLastActiveCookie } from './cookie';
import { AUTH_COOKIES, OG_COOKIE } from '../constants/cookies';

const INACTIVITY_THRESHOLD = 30 * 60 * 1000;
const REFRESH_TIME = 5 * 60 * 1000;

export const isUserLoggedIn = () => {
    const accessToken = Cookies.get(AUTH_COOKIES.ACCESS_TOKEN);
    return !!accessToken;
};

export const checkLastActive = () => {
    const lastActiveCookie = Cookies.get(AUTH_COOKIES.LAST_ACTIVE);

    if (!lastActiveCookie) {
        return false;
    }

    const lastActiveTimestamp = parseInt(lastActiveCookie, 10);
    const currentTime = Date.now();

    return currentTime - lastActiveTimestamp >= INACTIVITY_THRESHOLD;
};

export const isTokenExpiringSoon = () => {
    const tokenExpiry = Cookies.get(AUTH_COOKIES.TOKEN_EXPIRY);

    if (!tokenExpiry) {
        return false;
    }

    const tokenExpiryTime = parseInt(tokenExpiry, 10);
    const currentTime = Date.now();

    return tokenExpiryTime - currentTime <= REFRESH_TIME;
};

export async function logoutUser() {
    try {
        const response = await fetch(`/api/acp/auth/logout`, {
            method: 'POST',
        });

        if (response.status === 200) {
            console.log('User successfully logged out.');
            Cookies.remove(OG_COOKIE);

            const isTreatsRewardsAuthenticatedPage = window.location.href.includes('treats-rewards/authenticated');

            window.location.assign(isTreatsRewardsAuthenticatedPage ? '/treats-rewards' : '/sign-in');
        }
    } catch (error) {
        console.error('Error during logout:', error);
    }
}

// TODO: Review this quick later (fix to prevent multiple refresh requests)
let isRefreshingUserToken = false;

export async function refreshUserToken() {
    if (isRefreshingUserToken) {
        return;
    }

    try {
        isRefreshingUserToken = true;

        const response = await fetch(`/api/acp/auth/refresh-token`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.status === 200) {
            console.log('User tokens successfully refreshed.');
        }
    } catch (error) {
        console.error('Error during refresh token:', error);
    } finally {
        isRefreshingUserToken = false;
    }
}

export const evaluateSession = async () => {
    if (isUserLoggedIn()) {
        if (checkLastActive()) {
            await logoutUser();
        } else if (isTokenExpiringSoon()) {
            await refreshUserToken();
        } else {
            setLastActiveCookie();
        }
    }
};
